import { render, staticRenderFns } from "./ModalAsset.vue?vue&type=template&id=3b6312fd&"
import script from "./ModalAsset.vue?vue&type=script&lang=ts&"
export * from "./ModalAsset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6312fd')) {
      api.createRecord('3b6312fd', component.options)
    } else {
      api.reload('3b6312fd', component.options)
    }
    module.hot.accept("./ModalAsset.vue?vue&type=template&id=3b6312fd&", function () {
      api.rerender('3b6312fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/reports/StockReport/ModalAsset.vue"
export default component.exports